// extracted by mini-css-extract-plugin
export default {"root":"y4blxytGznHStQLWnr3k","placeHolderShimmer":"S3cIba4V_Mad9dcaqliY"};